export const PROTECTED = 'PROTECTED'
export const AUTHENTICATED = 'AUTHENTICATED'
export const TOKEN_FREE = 'TOKEN_FREE'
